export default "__VITE_ASSET__94348439__"